import { AllFlags } from '@mode/shared/contract-common';
import { Operation } from 'diffj/dist/lib/jsonPatch';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RpcMessages {
  export enum MessageTypes {
    InitReport = 'rpc.InitReport',
    InitCellResults = 'rpc.InitCellResults',
    UpdateState = 'rpc.updateState',
  }

  export class EmptyResponse {
    constructor(
      public readonly ok: boolean,
      public readonly error?: string
    ) {}
  }

  export class InitReport {
    readonly type = MessageTypes.InitReport;

    constructor(
      public readonly layout: string,
      public readonly baseThemeHref: string,
      public readonly customSource: string,
      public readonly launchDarklyFlags: AllFlags,
      public readonly embed_id?: string
    ) {}
  }

  export class InitCellResults {
    readonly type = MessageTypes.InitCellResults;

    constructor(public readonly content: string) {}
  }

  export class UpdateState {
    readonly type = MessageTypes.UpdateState;

    constructor(public readonly diff: Operation[]) {}
  }
}
